<template>
  <section class="partnersBar">
    <div v-for="partner in partnersList" :key="partner.name" class="logoWrapper">
      <img :alt="partner.name" :src="partner.logo" class="partnerLogo" />
    </div>
  </section>
</template>

<script setup>
import { shape, arrayOf, string } from 'vue-types'

import DefaultPartnersList from 'components/reused-components/partnersBar/DefaultPartnersList'

defineProps({
  partnersList: arrayOf(
    shape({
      name: string().isRequired,
      logo: string().isRequired,
    }).loose.isRequired
  ).def(DefaultPartnersList),
})
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';

.partnersBar {
  display: flex;
  flex-wrap: wrap;
  gap: 2%;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 24px;
  background-color: $color-white;

  @media (min-width: $screen-sm-min) {
    padding: 40px 120px;
  }

  .logoWrapper {
    width: 8%;
    min-width: 50px;
    max-width: 130px;
    margin: 12px auto;

    .partnerLogo {
      width: 100%;
      aspect-ratio: 1/1;
      object-fit: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PartnersBar.vue